<div class="MainDiv">
	<div>
		<caass-manual-selector-extended-info [AudienceMode]="AudienceMode" [SelectedPerson]="SelectedPerson" [FacilityID]="FacilityID">
		</caass-manual-selector-extended-info>
	</div>

	<!--Attendance section-->
	<div class="TopMargin">
		<h5>Recent Attendance (Last 20 Attendance Records)</h5>

		<p-table
			#mydt
			[value]="lstAttendance"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[paginator]="true"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedEntry"
			dataKey="AttendanceDateStr"
			(onFilter)="onHandleFilter($event)"
			(onSort)="onHandleSort($event)"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 20]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Column Names-->
				<tr style="height: 4rem">
					<th pSortableColumn="AttendanceDateStr">Date<p-sortIcon field="AttendanceDateStr"></p-sortIcon></th>
					<th pSortableColumn="AttendanceTimeStr">Time<p-sortIcon field="AttendanceTimeStr"></p-sortIcon></th>
					<th pSortableColumn="AttendanceStatusDesc">Status<p-sortIcon field="AttendanceStatusDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-entry>
				<tr [pSelectableRow]="entry">
					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ entry[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>
